import * as type from './types';
import property from 'lodash/property';
import { _sendLog } from '../../utils/utility';
import axios from "axios";


export function _setSite(site: string) {
    return (dispatch: any, getState: any) => {
        dispatch({
            type: type.SET_SITE,
            site: site
        });
    }
}

export function _setStep(step: number) {
    return (dispatch: any, getState: any) => {
        const prevStep : any = _getStep(getState())
        if (step > prevStep) {
            dispatch({
                type: type.SET_STEP,
                step: step
            });
        }
    }
}

export function _showError(errors: string[]) {
    console.log(errors);
    return (dispatch: any, getState: any) => {
        dispatch({
            type: type.SHOW_ERROR,
            errors: errors
        });
    }
}

export function _clearError() {
    return (dispatch: any, getState: any) => {
        dispatch({
            type: type.CLEAR_ERROR
        });
    }
}


export function _showModal(data: type.ModalType) {
    return (dispatch: any, getState: any) => {
        dispatch({
            type: type.SHOW_MODAL,
            data: data
        });
    }
}

export function _hideModal() {
    return (dispatch: any, getState: any) => {
        dispatch({
            type: type.HIDE_MODAL,
        });
    }
}
export function _showSpinner() {
    return (dispatch: any, getState: any) => {
        dispatch({
            type: type.SHOW_SPINNER
        });
    }
}

export function _hideSpinner() {
    return (dispatch: any, getState: any) => {
        dispatch({
            type: type.HIDE_SPINNER
        });
    }
}

export function _checkPaynowAvailable(){
    return (dispatch: any, getState: any) => {
        return new Promise((resolve, reject) => {
            const server = (process.env.REACT_APP_ENV  === 'dev' ? process.env.REACT_APP_LOCAL_URL : '');
            // @ts-ignore
            axios.post(server + process.env.REACT_APP_CHECK_PAYNOW_STATUS_URL, {countryCode: "SGP"}, {headers: {'Content-Type': 'application/json'}})
                .then(resp => {
                    console.log("_checkPaynowAvailable country return="+resp.data);
                        let paynowAvailable = resp.data?.toString() === "true";
                        console.log("_checkPaynowAvailable country paynowAvailable="+paynowAvailable);
                        dispatch({
                            type: type.SET_PAYNOW_AVAILABLE,
                            paynowAvailable: paynowAvailable
                        });
                        resolve(paynowAvailable);
                    })
                .catch(error => {
                    console.error(error);
                    _sendLog(['SME-React - System Service - _checkPaynowAvailable: ', error]);
                    reject(new Error(error));
                });
        })
    };
}

export function _checkSystemAvailable() {
    return (dispatch: any, getState: any) => {
        return new Promise((resolve, reject) => {
            const server = (process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCAL_URL : '');
            const httpOptions = { headers: {'Content-Type': 'application/json'} };

            // @ts-ignore
            axios.post(server + process.env.REACT_APP_CHECK_SYSTEM_STATUS_URL, {countryCode: "SGP"}, httpOptions)
                .then(resp => {
                    const systemAvailable = resp.data?.toString() === "true";
                    dispatch({
                        type: type.SET_SYSTEM_AVAILABLE,
                        systemAvailable: systemAvailable
                    });
                    resolve(systemAvailable);
                })
                .catch(error => {
                    _sendLog(['PAN-React - System Service - _checkSystemAvailable: ', error]);
                    reject(error);
                });
        });
    }
}

export function _getScheduledMaintenance() {
    return async (dispatch: any, getState: any) => {
        return new Promise((resolve, reject) => {
            const server = (process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCAL_URL : '');
            const httpOptions = { headers: {'Content-Type': 'application/json'} };

            // @ts-ignore
            axios.post(server + process.env.REACT_APP_CHECK_SCHEDULED_MAINTENANCE_URL, {countryCode: "SGP"}, httpOptions)
                .then(resp => {
                    if(resp) {
                       resolve(resp);
                    }
                })
                .catch(error => {
                    _sendLog(['PAN-React - System Service - _checkSystemAvailable: ', error]);
                    reject(error);
                });
        });
    }
}


export const _getBanners = (product: any) => {
    return async (dispatch: any, getState:any) => {
        return new Promise((resolve, reject) => {
            const server = (process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCAL_URL : '');
            let config = {
                params: {
                    country: "SGP",
                    product: product
                },
                headers: {'Content-Type': 'application/json'},
            }
            // @ts-ignore
            axios.get(server + process.env.REACT_APP_GET_BANNERS_URL, config)
                .then(resp => {
                    if(resp) {
                       resolve(resp);
                    }
                })
                .catch(error => {
                    _sendLog(['PAN-React - System Service - _getBanners: ', error]);
                    reject(error);
                });
        });
    }
}

export const _getSite = property('sys.site');

export const _getStep = property('sys.step');

export const _getErrors = property('sys.errors');

export const _getShowError = property('sys.showError');

export const _getShowModal = property('sys.showModal');

export const _getModal = property('sys.modal');

export const _getPaynowAvailable = property('sys.paynowAvailable');

export const _getShowSpinner = property('sys.spinner');

export const _getSystemAvailable = property('sys.systemAvailable');

